<template>
  <div style="width: 600px;margin: 30px auto 0;">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-form-item label="原手机号" prop="oldPwd">
        {{ phoneNum }}
      </el-form-item>
      <el-form-item label="新手机号" prop="newPhone">
        <el-input v-model="form.newPhone" placeholder="请输入新手机号" />
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input v-model="form.pwd" show-password placeholder="请输入密码" />
      </el-form-item>
      <el-form-item label="验证码" prop="verifyCode" required>
        <div style="display: flex;">
          <el-input
            v-model="form.verifyCode"
            placeholder="请输入验证码"
            style="width: 200px;"
            maxlength="6"
          />
          <!-- !form.phone || !isPhoneValid || -->
          <el-button
            type="primary"
            :disabled="countdown > 0"
            style="margin-left: 10px;"
            @click="getVerifyCode"
          >
            {{ countdown > 0 ? `${countdown}秒后重试` : "获取验证码" }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="getLimit('updatePassword_submit_button')"
        type="primary"
        @click="funcSubmit"
      >
        立即提交
      </el-button>
      <el-button
        v-if="getLimit('updatePassword_reset_button')"
        @click="resetForm('form')"
      >
        重 置
      </el-button>
    </div>
  </div>
</template>
<script>
import { updatePhone } from "@/api/user";
import { checkPassword } from "@/utils/validate4Form";
const Base64 = require("js-base64").Base64;
import { updatePSW, sendVerificationCode, editPSW } from "@/api/pay.js";
export default {
  name: "UpdatePassword",
  components: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      countdown: 0,
      timer: null,
      form: {
        oldPwd: "",
        newPwd: "",
        newPwd2: ""
      },
      rules: {
        newPhone: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
        pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    phoneNum() {
      let party = this.$store.getters.party;
      return party.phone;
    }
  },
  methods: {
    async getVerifyCode() {
      // this.$refs.form.validateField("phone", async valid => {
      //   if (!valid) {
      if (!this.form.newPhone) {
        this.$message.error("请输入新手机号");
        return;
      }
      // 正则检测
      if (!/^1[3-9]\d{9}$/.test(this.form.newPhone)) {
        this.$message.error("请输入正确的新手机号");
        return;
      }
      try {
        let res = await sendVerificationCode({
          phone: this.form.newPhone, // this.form.phone,
          partyGroupCode: this.$store.state.user.party.branchCode
        });
        console.log("发送验证码=======", res);
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (error) {
        console.error("获取验证码失败:", error);
        this.$message.error("获取验证码失败，请稍后重试");
      }
      //   }
      // });
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let data = {};
          data.oldPhone = this.phoneNum;
          data.newPhone = this.form.newPhone;
          data.verifyCode = this.form.verifyCode;
          data.pwd = Base64.encode(this.form.pwd);
          data.branchCode = this.$store.state.user.party.branchCode;
          const rLoading = this.openLoading();
          updatePhone(data)
            .then(response => {
              if (response.status == 0) {
                rLoading.close();
                this.$message({ message: response.msg, type: "success" });
                localStorage.clear();
                this.$router.replace("/login");
              }
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 330px;
  float: right;
}
</style>
